import { Text } from "@/components/atoms/Text";
import { Alert, AlertDescription } from "@/components/molecules/Alert";
import HeartIcon from "@/icons/__generated__/Heart/Heart20";
import ShareIcon from "@/icons/__generated__/Share/Share20";

interface ShareNudgeAlertProps {
  isVisible: boolean;
  message: React.ReactNode;
  ctaBtnText: React.ReactNode;
  onDismiss: () => void;
  onShareClick: () => void;
  experimentName: string;
}

export function ShareNudgeAlert({
  isVisible,
  message,
  ctaBtnText,
  onDismiss,
  onShareClick,
  experimentName,
}: ShareNudgeAlertProps) {
  const nudgeIcon =
    experimentName === "listing_save_nudge" ? (
      <HeartIcon className="tw-shrink-0" />
    ) : (
      <ShareIcon className="tw-shrink-0" />
    );
  return (
    <div className="tw-fixed tw-bottom-[72px] md:tw-bottom-16 tw-left-0 tw-right-0 tw-z-max tw-flex tw-justify-center md:tw-justify-end tw-px-16 tw-pointer-events-none">
      <div className="tw-max-w-[420px] tw-w-full tw-pointer-events-auto tw-shadow-xl">
        <Alert
          appearance="purple"
          isVisible={isVisible}
          onDismiss={onDismiss}
          className="tw-shadow-xl tw-rounded-8 tw-border-none"
        >
          <AlertDescription className="tw-mb-0">
            <span className="tw-flex tw-gap-8 tw-items-start">
              {nudgeIcon}
              <span>
                <Text
                  typeface="body-1-m"
                  element="span"
                  className="tw-block tw-pb-8"
                >
                  {message}
                </Text>
                <Text
                  className="tw-underline tw-cursor-pointer"
                  typeface="body-1-m"
                  element="button"
                  onClick={onShareClick}
                >
                  {ctaBtnText}
                </Text>
              </span>
            </span>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}
